import FeatureEnabledDashboard from 'portal/src/layouts/base/FeatureEnabledDashboard';

import isInverseModelDashboardEnabled from './isInverseModelDashboardEnabled';

export default function InverseModelDashboard({
  slug,
}: {
  slug: string;
}): React.ReactElement {
  return (
    <FeatureEnabledDashboard
      slug={slug}
      isFeatureEnabled={isInverseModelDashboardEnabled}
    />
  );
}
